import React, { ReactElement, useState } from "react";
import { useFormikContext } from "formik";
import { FieldWrapper } from "./FieldWrapper";
import { Box } from "@chakra-ui/react";
import {
  AutoComplete,
  AutoCompleteGroup,
  AutoCompleteInput,
  AutoCompleteItem,
  AutoCompleteList,
  AutoCompleteCreatable,
} from "@choc-ui/chakra-autocomplete";

interface Props {
  options: string[];
  name: string;
  height?: string;
  tagScheme?: string;
  variant?: string;
  placeholder?: string;
  label?: string;
  multiple?: boolean;
  borderColor?: string;
  borderHoverColor?: string;
  callback?: (value: string) => void;
}

export function SuggestionField({
  options,
  name,
  label,
  height,
  borderColor = "#0088cc",
  borderHoverColor,
  callback = (val) => {},
}: Props): ReactElement {
  const formikProps = useFormikContext();
  const [value, setValue] = useState(formikProps.values[name]);

  const onChange = (val) => {
    formikProps.setFieldValue(name, val);
    setValue(val);
    callback(val);
  };

  return (
    <FieldWrapper name={name} label={label}>
      <Box
        borderColor={borderColor}
        borderRadius="md"
        borderWidth="2px"
        background="white"
        maxH={height || "6vh"}
        h={height}
        _focus={{ borderColor: borderHoverColor }}
        _hover={{ borderColor: borderHoverColor }}
      >
        <AutoComplete openOnFocus onChange={onChange} multiple={false} border="solid 0px black" focusInputOnSelect={true} value={value} creatable>
          <AutoCompleteInput border="solid 0px black" variant="no_border" fontFamily="galdeano" fontSize="1.2rem" color="black"></AutoCompleteInput>
          <AutoCompleteList>
            <AutoCompleteGroup>
              {options.map((option, id) => (
                <AutoCompleteItem key={`option-${id}`} value={option} _selected={{ fontWeight: "extrabold" }}>
                  {option}
                </AutoCompleteItem>
              ))}
            </AutoCompleteGroup>
            <AutoCompleteCreatable />
          </AutoCompleteList>
        </AutoComplete>
      </Box>
    </FieldWrapper>
  );
}
